import React, { Component } from "react";
import Buttons from "./Buttons";
import Image from "./Image";
import Video from "./Video";

const isExternalButton = (button) => button.type === "LINK_BUTTON";

class Message extends Component {
  from = "fromBot";
  message = "";
  buttons = [];
  images = [];
  videos = [];

  sendButtonResponse = (message) => {
    this.props.onSubmitButtonResponse(message);
    this.setState({ triggered: true });
  };

  isExternal = () => {
    return this.props.buttons.length > 0
      ? this.props.buttons.every(isExternalButton)
      : false;
  };

  render() {
    return (
      <div
        className={[
          this.props.from,
          this.isExternal() === true ? "external" : "",
        ].join(" ")}
      >
        {this.props.message && (
          <div className="message">{this.props.message}</div>
        )}
        {this.props.buttons.length > 0 && (
          <Buttons
            buttons={this.props.buttons}
            onSubmitButtonResponse={(message) =>
              this.sendButtonResponse(message)
            }
          />
        )}

        {this.props.images.length > 0 && (
          <div className="message responseImage">
            {this.props.images.map((image, index) => (
              <Image key={index} title={image.title} url={image.link} />
            ))}
          </div>
        )}

        {this.props.videos.length > 0 && (
          <div className="message responseVideo">
            {this.props.videos.map((image, index) => (
              <Video key={index} title={image.title} url={image.link} />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Message;
